module.exports = __webpack_public_path__ + "img/jushibaojie_icon_zhujie.670ef4cc.png";